<template>
  <div>
    <div class="md:ml-20 ml-0">
      <div>
        <h1 class="text-4xl font-semibold text-ungu">Giro Bank Maluku Malut</h1>
      </div>
      <div>
        <p class="mt-5 text-sm leading-loose text-paragraf">
          Merupakan simpanan nasabah yang penarikan dan penyetorannya dapat
          dilakukan sewaktu-waktu dengan menggunakan warkat yang telah
          ditentukan. Giro Bank Maluku Malut memberikan segala kemudahan bagi
          anda untuk melakukan transaksi demi kelancaran kegiatan dan bisnis
          anda.
        </p>
      </div>
      <div class="text-paragraf text-sm">
        <img class="hover:scale-105 duration-500 md:-ml-0 lg:scale-100 scale-100 mt-5" src="@/assets/giro.png" />
        <!-- BUTTON -->
        <div class=" duration-300 shadow-btn-download w-[250px] mt-5 flex  cursor-pointer">
          <div class="bg-blue-maluku h-12 w-14 box-content rounded-lg rounded-r-none">
            <div class="flex justify-center py-3 ">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="#ffff"
                class="w-6 h-6">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
              </svg>
            </div>
          </div>
          <div
            class="grid hover:bg-blue-maluku duration-300 ease-linear bg-white h-12 w-48 box-content rounded-lg rounded-l-none">
            <div
              class="grid grid-cols-1 justify-items-center content-center hover:text-white text-blue-maluku font-semibold text-lg">
              Download Brosur
            </div>
          </div>
        </div>



        <p class="font-semibold text-2xl mt-7 text-ungu">
          Syarat Giro
        </p>
        <div class="mt-3 flex justify-start">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
            stroke="currentColor" class="mr-2 pt-1 w-5 h-5">
            <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" />
          </svg>
          <p>Various analysis options.</p>
        </div>
        <div class="mt-2 flex justify-start">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
            stroke="currentColor" class="mr-2 pt-1 w-5 h-5">
            <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" />
          </svg>
          <p>Page Load (time, number of requests).</p>
        </div>
        <div class="mt-2 flex justify-start">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
            stroke="currentColor" class="mr-2 pt-1 w-5 h-5">
            <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" />
          </svg>
          <p>Big data analysis.</p>
        </div>
        <div class="mt-2 flex justify-start">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
            stroke="currentColor" class="mr-2 pt-1 w-5 h-5">
            <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" />
          </svg>
          <p>Lorem analysis somthing.</p>
        </div>
      </div>
      <p class="mt-3 text-sm leading-loose text-paragraf">
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas
        interdum, orci at dapibus, massa ante pharetra tellus. Maecenas
        interdum, orci at euismod dapibus. Lorem ipsum dolor sit amet,
        consectetur adipiscing elit. Maecenas interdum.
      </p>
    </div>
  </div>
</template>
<script>
import Button from 'primevue/button'

export default {

  setup() { },
};
</script>